module.exports = __webpack_public_path__ + "static/gallery35-4ff57be10eea8a70552dce2cda8bb30b.jpg";